module.exports = __webpack_public_path__ + "img/android_prod.e49eb289.png";